import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { PlanejamentoCarga } from '../../types/estoque';
import { planejamentoCargasService } from '../../services';

const fields: ResourceField<PlanejamentoCarga>[] = [
  { name: 'data_planejamento', label: 'Data de planejamento', type: 'date' },
  { name: 'transportadora', label: 'Transportadora' },
  { name: 'capacidade_total_kg', label: 'Capacidade (kg)', type: 'number' },
  { name: 'capacidade_total_m3', label: 'Capacidade (m³)', type: 'number' },
  { name: 'status', label: 'Status', type: 'select', options: [{ label: 'Planejando', value: 'PLANEJANDO' }, { label: 'Confirmado', value: 'CONFIRMADO' }, { label: 'Em carregamento', value: 'EM_CARREGAMENTO' }, { label: 'Expedido', value: 'EXPEDIDO' }] },
  { name: 'observacoes', label: 'Observações', type: 'textarea' }
];

export const PlanejamentoCargasFormPage: React.FC = () => (
  <ResourceFormPage
    title="Planejamento de carga"
    description="Configure o carregamento."
    fields={fields}
    service={ planejamentoCargasService }
    redirectPath="/admin/estoque/planejamento-cargas"
    cancelPath="/admin/estoque/planejamento-cargas"
  />
);
